<template>
    <div class="container">
        <h1>Reset Password</h1>
        <p>{{ email }}</p>
        <form @submit.prevent="resetPassword">
            <input type="password" v-model="newPassword" placeholder="Enter new password" required>
            <input type="submit" value="Reset Password">
        </form>
        <p id="message" :style="{ color: messageColor }">{{ message }}</p>
        <button v-if="showCloseButton" :class="buttonClass" @click="closeWindow">Close</button>
    </div>
</template>

<script>
import config from '@/config.js';
export default {
    data() {
        return {
            email: '',
            token: '',
            newPassword: '',
            message: '',
            messageColor: '',
            showCloseButton: false,
            buttonClass: '',

            dbname: '',
        };
    },
    created() {
        const urlParams = new URLSearchParams(window.location.search);
        this.token = urlParams.get('token');
        this.email = `Email: ${urlParams.get('email')}`;

        this.dbname = urlParams.get('dbname');
    },
    methods: {
        async resetPassword() {
            let reset_url

            try{

                if (!this.dbname  || this.dbname === 'myant' || this.dbname === 'ant'){
                    reset_url = `${config.base_reset_confirm_url}?dbname=ant`
                }  else if (this.dbname === 'sys') {
                    reset_url = `${config.base_reset_confirm_url}?dbname=sys`;
                    console.log(reset_url)
                } 
                
                const response = await fetch(reset_url, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        token: this.token,
                        new_password: this.newPassword
                    })
                });

                const result = await response.json();

                if (response.ok) {
                    this.message = 'Password reset successful!';
                    this.messageColor = 'green';
                    this.buttonClass = 'success';
                } else {
                    this.message = `Error: ${result.detail}`;
                    this.messageColor = 'red';
                    this.buttonClass = 'error';
                }

                this.showCloseButton = true;
            }catch(e){
                console.log('reset error--->', e)
            }    
        },

        closeWindow() {
            window.opener = null;
            window.open("about:blank", "_self");
            window.close();
        }
    }
};
</script>

<style scoped>
body {
    font-family: Arial, sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f4f4f4;
    margin: 0;
}

.container {
    background-color: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    max-width: 400px;
    width: 100%;
}

h1 {
    margin-bottom: 20px;
    font-size: 24px;
    color: #333;
}

p {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
}

input[type="password"],
input[type="submit"],
button {
    width: 100%;
    padding: 10px;
    margin: 10px 0;
    border-radius: 4px;
    border: 1px solid #ccc;
    box-sizing: border-box;
}

button {
    color: white;
    border: none;
    cursor: pointer;
}

button.success {
    background-color: #4CAF50;
}

button.success:hover {
    background-color: #45a049;
}

button.error {
    background-color: #f44336;
}

button.error:hover {
    background-color: #d32f2f;
}

#message {
    margin-top: 20px;
    font-size: 14px;
}
</style>